import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const LayerFull = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25612 1.51787C7.32737 0.82617 8.70481 0.827475 9.77475 1.52121L14.3207 4.46874C15.4458 5.19824 15.4458 6.84485 14.3207 7.57432L13.6056 8.03794L14.181 8.41092C15.3972 9.19926 15.3972 10.9791 14.181 11.7674L9.90072 14.542C8.7443 15.2916 7.25561 15.2929 6.09796 14.5451L1.80011 11.7692C0.580275 10.9813 0.580271 9.19702 1.8001 8.40913L2.38993 8.02816L1.68944 7.5758C0.56051 6.84676 0.56056 5.19546 1.68953 4.46649L6.25612 1.51787ZM3.31156 8.62333L2.34267 9.24914C1.73275 9.64309 1.73275 10.5352 2.34267 10.9292L6.64052 13.7051C7.46742 14.2392 8.53076 14.2383 9.35678 13.7029L13.6371 10.9283C14.2452 10.5341 14.2452 9.64421 13.6371 9.25004L12.6865 8.63386L9.77483 10.5217C8.70484 11.2154 7.32734 11.2166 6.25609 10.5248L3.31156 8.62333Z"
        fill={color}
      />
    </svg>
  )
})

export default LayerFull
